// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingGenericListPanel_root__2KCjS","form":"EditListingGenericListPanel_form__1l0_P","title":"EditListingGenericListPanel_title__3EbQW"};